module.exports = __webpack_public_path__ + "static/media/main.b1169c47.jpg";